import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";



function CleaningSwapPaymentSuccess() {
  const { dealId } = useParams();
  const navigate = useNavigate();

  const [deal, setDeal] = useState(null);
  const [payment, setPayment] = useState(null);
  const [statusText, setStatusText] = useState(
    "Payment received. Waiting for the other party to complete payment…"
  );

  useEffect(() => {
    const loadData = async () => {
      try {
        // 1️⃣ Load deal
      const token = localStorage.getItem("token");

const dealRes = await fetch(
  `${API_BASE_URL}/api/cleaning/swaps/deal/${dealId}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

 if (dealRes.ok) {
  const dealData = await dealRes.json();
 setDeal(dealData.deal);

 setPayment(dealData.payment || null);

  const swapStatus = dealData.deal?.swap_status;
  console.log("Swap status:", swapStatus);

  if (swapStatus === "payment_required") {
    setStatusText(
      "Payment received. Waiting for the other party to complete payment…"
    );
  }

  if (swapStatus === "handover") {
    setStatusText(
      "Both payments received. Your swap is now active and has moved to handover."
    );
  }
}

        // 2️⃣ Load latest PAID payment for this deal

      } catch (err) {
        setStatusText(
          "Payment received. Waiting for the other party…"
        );
      }
    };

    loadData();
    const interval = setInterval(loadData, 5000);
    return () => clearInterval(interval);
 }, [dealId]);

  return (
    <div style={{ padding: 40, maxWidth: 720, margin: "0 auto" }}>
      <h2 style={{ textAlign: "center" }}>✅ Payment Successful</h2>

      <p style={{ textAlign: "center", marginTop: 10 }}>
        {statusText}
      </p>

      <hr style={{ margin: "30px 0" }} />

      {/* ================= RECEIPT ================= */}
      <h3>Transaction Receipt</h3>

      <p>
        <strong>Deal ID:</strong> #{dealId}
      </p>

      <p>
<strong>Fee Paid:</strong>{" "}
{payment?.amount
  ? `$${Number(payment.amount).toFixed(2)} AUD`
  : "Swap fee paid successfully"}
      </p>

      {payment && (
        <>
          <p>
            <strong>Stripe Transaction ID:</strong>{" "}
            <code>{payment.stripeSessionId}</code>
          </p>

          <p>
            <strong>Paid At:</strong>{" "}
            {new Date(payment.created_at).toLocaleString()}
          </p>
        </>
      )}

      <p>
        <strong>Payment Status:</strong>{" "}
        <span style={{ color: "#2e7d32" }}>Paid</span>
      </p>

      <hr style={{ margin: "30px 0" }} />

      {/* ================= NEXT STEPS ================= */}
      <h3>What happens next?</h3>

      <ul style={{ lineHeight: "1.8" }}>
        <li>
          Your payment has been securely received by Client Exchange.
        </li>
        <li>
          The other party must now complete their swap fee.
        </li>
        <li>
          Once both payments are complete, the swap moves to
          <strong> handover</strong>.
        </li>
        <li>
          You’ll receive an email when the swap is activated.
        </li>
      </ul>

      <div style={{ marginTop: 30, textAlign: "center" }}>
        <button
          onClick={() => navigate("/dashboard")}
          style={{
            padding: "10px 22px",
            background: "#2e7d32",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

export default CleaningSwapPaymentSuccess;
